export default __webpack_public_path__ + "static/media/dz.9e58392b.svg";